import React, { ReactNode, useEffect, useState } from 'react';
import { BellFilled } from '@ant-design/icons';
import { Avatar, Badge, Dropdown, MenuProps, Popover } from 'antd';
import { Header } from 'antd/es/layout/layout';
import { IProps } from 'components/Button';
import { useUser } from 'contexts/User';
import { avatar } from 'assets/images';
import PageTitle from './PageTitle';
import { useHistory } from 'react-router-dom';
import { CartBlue, Settings } from 'assets/svg';
import CartIcon from '../Cart/CartIcon';
import { useMutation, useQuery } from 'react-query';
import CartApi from 'apis/CartApi';

const MainHeader = (): JSX.Element => {
  const { user, signOut } = useUser();
  const history = useHistory();
  const items: MenuProps['items'] = [
    {
      key: '2',
      label: (
        <a
          onClick={() => {
            history.push(`/profile`);
          }}
        >
          Cá nhân
        </a>
      ),
    },
    {
      key: '1',
      label: <a onClick={signOut}>Đăng xuất</a>,
    },
  ];

  const [total, setTotal] = useState(0);

  const { isLoading: getCartOrderTVV, mutate: refetch } = useMutation(
    ['getCartOrderTVV'],
    () => {
      return CartApi.getCartOrderTVV(user?.plantId)
        .then((res) => {
          setTotal(res?.count);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  );

  useEffect(() => {
    if (user) {
      refetch();
    }
  }, [user]);

  return (
    <Header
      className="flex items-center justify-between z-10"
      style={{ paddingTop: '5px' }}
    >
      <PageTitle></PageTitle>
      <div className="flex items-center justify-end">
        {(user?.role.includes('cua_hang_truong') ||
          user?.role.includes('nguoi_dat_hang')) && (
          <div className="mr-5 cursor-pointer">
            {total > 0 ? (
              <Popover
                placement="bottomRight"
                content={<CartIcon />}
                trigger={'click'}
              >
                <Badge count={total}>
                  <CartBlue />
                </Badge>
              </Popover>
            ) : (
              <Badge>
                <CartBlue />
              </Badge>
            )}
          </div>
        )}

        {/* <BellFilled className="text-primary-50 mr-4" /> */}
        <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
          <div className="flex items-center cursor-default">
            {/* <div className="w-10 h-10 rounded-full flex justify-center items-center overflow-hidden mr-2">
              <img
                src={
                  user?.documents == null || user?.documents?.length == 0
                    ? ''
                    : user?.documents[0]
                }
                alt="avatar"
              />
            </div> */}
            <div className="text-primary-50 font-bold text-sm">
              {user?.fullName + ' ›'}
            </div>
          </div>
        </Dropdown>
      </div>
    </Header>
  );
};

export default MainHeader;
